import React from "react";
import "./TitleScreen.css"; 

const TitleScreen = () => {
    return (
        <div className="title-container">
            {/* <h3>Hi!! My name is </h3> */}
            <h1>I'm Ashley Gonzalez Perez</h1>
            <p>Machine Learning | AI | Web Developer</p>
        </div>
    //     <div className="title-text">
    //     <p>Hi!! My name is</p>
    //     <h1>Ashley Gonzalez Perez</h1>
    //     <p>Computer Science & Engineering</p>
    // </div>
    );
};

export default TitleScreen;
